<template>
  <div class="bz-radius-map">
    <div v-show="ready" ref="map" class="bz-radius-map-canvas"></div>
    <div v-if="!ready" class="bz-map-ph" style="height:180px;">
      <span>{{ failed ? 'map unavailable' : (address ? 'locating…' : 'map preview') }}</span>
    </div>
  </div>
</template>

<script>
// Live radius preview: geocodes the address/ZIP and draws the radius circle.
// Uses the same google-maps loader + API key pattern as the app's existing
// map pages (Dashboard/Components/GoogleMapLoader.vue). Fails soft back to
// the placeholder — the radius selection itself never depends on the map.
import { Loader } from 'google-maps';

const API_KEY = process.env.VUE_APP_GOOGLE_MAP_KEY || 'AIzaSyB1s8BSk8ML5V1XTkcn1s7pgxApFHBN4Hw';
let loaderPromise = null;

export default {
  name: 'radius-map',
  props: {
    address: { type: String, default: '' },
    miles: { type: Number, default: 25 },
  },
  data() {
    return { google: null, map: null, circle: null, marker: null, ready: false, failed: false, timer: null };
  },
  watch: {
    address() {
      this.debouncedUpdate();
    },
    miles() {
      if (this.circle) this.circle.setRadius(this.miles * 1609.34);
      this.fitCircle();
    },
  },
  async mounted() {
    try {
      if (!loaderPromise) loaderPromise = new Loader(API_KEY, {}).load();
      this.google = await loaderPromise;
      this.debouncedUpdate();
    } catch (e) {
      this.failed = true;
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    debouncedUpdate() {
      clearTimeout(this.timer);
      if (!this.address || !this.address.trim() || !this.google) return;
      this.timer = setTimeout(this.update, 700);
    },
    update() {
      const g = this.google;
      new g.maps.Geocoder().geocode({ address: this.address.trim() }, (results, status) => {
        if (status !== 'OK' || !results || !results.length) return;
        const center = results[0].geometry.location;
        if (!this.map) {
          this.map = new g.maps.Map(this.$refs.map, {
            center, zoom: 8, streetViewControl: false, fullscreenControl: false, mapTypeControl: false,
          });
          this.marker = new g.maps.Marker({ map: this.map, position: center });
          this.circle = new g.maps.Circle({
            map: this.map, center, radius: this.miles * 1609.34,
            strokeColor: '#003666', strokeWeight: 2, fillColor: '#003666', fillOpacity: 0.12,
          });
        } else {
          this.marker.setPosition(center);
          this.circle.setCenter(center);
          this.circle.setRadius(this.miles * 1609.34);
        }
        this.ready = true;
        this.fitCircle();
      });
    },
    fitCircle() {
      if (this.map && this.circle) this.map.fitBounds(this.circle.getBounds());
    },
  },
};
</script>

<style>
.bz-radius-map-canvas { height: 180px; border-radius: 8px; border: 1px solid #d3d8df; }
</style>
